import { ICommonIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders the microsoft office excel logo
 */
export function MicrosoftOfficeExcelLogo({
  className,
}: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 19 18">
      <g clipPath="url(#a)">
        <path
          className="fill-green-800"
          d="M12.074 8.145 4.787 6.86v9.502c0 .434.351.786.785.786h12.574a.786.786 0 0 0 .786-.786v-3.5l-6.858-4.716Z"
        />
        <path
          className="fill-green-600"
          d="M12.074.001H5.572a.786.786 0 0 0-.785.786v3.5l7.287 4.287 3.858 1.286 3-1.286V4.287L12.074.001Z"
        />
        <path
          className="fill-green-700"
          d="M4.787 4.287h7.287v4.287H4.787V4.287Z"
        />
        <path
          className="fill-black"
          d="M10.002 3.43H4.787v10.716h5.215a.788.788 0 0 0 .786-.786V4.215a.788.788 0 0 0-.786-.785Z"
          opacity={0.1}
        />
        <path
          className="fill-black"
          d="M9.573 3.858H4.787v10.717h4.786a.788.788 0 0 0 .786-.786V4.644a.788.788 0 0 0-.786-.786Z"
          opacity={0.2}
        />
        <path
          className="fill-black"
          d="M9.573 3.858H4.787v9.86h4.786a.788.788 0 0 0 .786-.786V4.644a.788.788 0 0 0-.786-.786Z"
          opacity={0.2}
        />
        <path
          className="fill-black"
          d="M9.145 3.858H4.787v9.86h4.358a.788.788 0 0 0 .785-.786V4.644a.788.788 0 0 0-.785-.786Z"
          opacity={0.2}
        />
        <path
          d="M1.286 3.858h7.859c.434 0 .785.352.785.786v7.859a.786.786 0 0 1-.785.786h-7.86a.786.786 0 0 1-.785-.786V4.644c0-.434.352-.786.786-.786Z"
          fill="url(#b)"
        />
        <path
          className="fill-white"
          d="m2.934 11.128 1.652-2.561L3.072 6.02H4.29l.827 1.628c.076.155.128.27.157.346h.01c.055-.124.112-.243.172-.36l.883-1.614h1.119L5.905 8.552l1.592 2.576h-1.19L5.352 9.34a1.5 1.5 0 0 1-.114-.239h-.014a1.13 1.13 0 0 1-.11.232l-.983 1.795H2.934Z"
        />
        <path
          className="fill-green-500"
          d="M18.146.001h-6.072v4.286h6.858v-3.5A.786.786 0 0 0 18.146 0Z"
        />
        <path
          className="fill-green-700"
          d="M12.074 8.574h6.858v4.287h-6.858V8.574Z"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="b"
          x1={2.138}
          x2={8.292}
          y1={3.244}
          y2={13.903}
        >
          <stop stopColor="#18884F" />
          <stop offset={0.5} stopColor="#117E43" />
          <stop offset={1} stopColor="#0B6631" />
        </linearGradient>
        <clipPath id="a">
          <path className="fill-white" d="M.5 0h18.432v17.146H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
}
